import {
    request,
    toast
} from '@/common/request.js';
import api from '@/common/api.js';

export function getUrl(n = 1) {
	let pages = getCurrentPages();
	let curPage = pages[pages.length - 1];
	let url = ''

	url = curPage.$route.fullPath;





	return url.substring(n, url.length);
}
export function getHref(url) {
	let href = url || window.location.href;
	let hrefIndex = href.indexOf("#");
	let hrefTwoIndex = href.indexOf("?")
	if ((hrefIndex == -1 && hrefTwoIndex != -1) || (hrefTwoIndex != -1 && hrefIndex > hrefTwoIndex)) {
		href = href.split("?")[0];
	} else {
		href = href.split("#")[0];
	}
	return href;
}

/**
 * @description 拼接参数
 * @property {String} url 链接
 * @property {String} data 额外追加的参数
 */
export function contractUrl(url, data = {}) {
	let resultObj = getUrlValue(url, data); // 过滤出能拼接得对象 -- 去重
	const queryUrl = splitData(resultObj); //链接参数转字符串
	let index = url.indexOf("?");
	index = index != -1 && queryUrl.length > 0 ? index + 1 : index;
	url = index == -1 ? queryUrl.length > 0 ? url + "?" : url : url.substr(0, index);
	return url + queryUrl;
}

// 获取链接参数并追加传递进来的参数(去重)
function getUrlValue(url, data = {}) {
	let index = url.indexOf("?");
	url = url.substr(index + 1);
	if (index == -1 || url == '') return data;
	let arr = url.split("&");
	let obj = {};
	arr.forEach((v) => {
		let val = v.split("=");
		obj[val[0]] = val[1] || ""
	})
	Object.assign(obj, data);
	return obj;
}

// 拆分数据
function splitData(data = {}) {
	let url = '';
	for (let k in data) {
		if (data.hasOwnProperty(k)) {
			let value = data[k] || ''
			if (typeof data[k] == 'number' && data[k] == 0) value = 0;
			url = url + '&' + k + '=' + encodeURIComponent(value)
		}
	}
	return url ? url.substring(1) : ''
}

/**
 * 拼接url
 * @param {String} path 页面路径 可携带参数 默认会携带sign和pid
 */
export function splicUrl(path = '/pages/index/index') {
	let sign = uni.getStorageSync("sign");
	let user = uni.getStorageSync("userInfo") ? uni.getStorageSync("userInfo") : {};
	let _url = path;
	const queryObj = { // 拼接得参数
		sign,
		pid: user.user_id || -1,
		mtaShareFlag: 1
	}
	_url = contractUrl(_url,queryObj);
	return _url
}

/* 
 * 小程序分享码获取数据
 */
export function getScene(){
	let url = getUrl();
	let obj = getUrlValue(url);
	let scene = obj.scene;
	if(!scene){
		return new Promise((resolve,rej) => {
			resolve('no')
		})
	}
	return new Promise((resolve,rej) => {
		request({
			url: api.setting.getScene,
			method: "POST",
			showLoading: false,
			data: {
				scene
			}
		}).then(res => {
			if(res.code == 0){
				uni.setStorageSync('pid', res.data.pid);
				uni.setStorageSync('source',res.data.source);
				resolve(res.data);
			} else {
				toast(res.msg)
			}
		})
	})
}
